<div class="offline-dialog">
  <!-- Header -->
  <div class="offline-dialog__header">
    <mat-icon class="offline-dialog__icon">wifi_off</mat-icon>
    <div>
      <h2 class="offline-dialog__title">Offline Payment</h2>
      <p class="offline-dialog__subtitle">Internet connection unavailable</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Order summary -->
  <div class="offline-dialog__body">
    <div class="offline-dialog__section-label">Order: {{ data.orderTitle }}</div>

    <div class="offline-dialog__items">
      <div class="item-row" *ngFor="let item of data.cartItems">
        <span class="item-row__name">
          <span *ngIf="getItemQty(item) > 1" class="item-row__qty">{{ getItemQty(item) }}x </span>{{ getItemDisplayName(item) }}
        </span>
        <span class="item-row__price">{{ formatCents(getItemPrice(item) * getItemQty(item)) }}</span>
      </div>
    </div>

    <!-- Totals block -->
    <div class="offline-dialog__totals">
      <div class="total-row">
        <span>Subtotal</span>
        <span>{{ formatCents(data.totals.subtotal) }}</span>
      </div>
      <div class="total-row" *ngIf="data.totals.tax > 0">
        <span>Tax</span>
        <span>{{ formatCents(data.totals.tax) }}</span>
      </div>
      <div class="total-row total-row--grand">
        <span>TOTAL</span>
        <span>{{ formatCents(data.totals.total) }}</span>
      </div>
    </div>

    <!-- Instructions -->
    <div class="offline-dialog__instructions" *ngIf="data.paymentMethod === 'card'">
      <mat-icon class="instructions__icon">credit_card</mat-icon>
      <p>
        Process payment on your Clover device using the device's normal payment flow.
        The device will handle the transaction offline and sync automatically when internet is restored.
      </p>
    </div>
    <div class="offline-dialog__instructions" *ngIf="data.paymentMethod === 'cash'">
      <mat-icon class="instructions__icon">payments</mat-icon>
      <p>Collect <strong>{{ formatCents(data.totals.total) }}</strong> in cash from the customer.</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Actions -->
  <div class="offline-dialog__actions">
    <button mat-button class="btn-cancel" (click)="cancel()" [disabled]="confirming">Cancel</button>
    <button
      mat-raised-button
      class="btn-confirm"
      color="primary"
      (click)="confirm()"
      [disabled]="confirming">
      <mat-spinner *ngIf="confirming" diameter="20" class="confirm-spinner"></mat-spinner>
      <span *ngIf="!confirming">Confirm Payment Received</span>
    </button>
  </div>
</div>
